import * as auth from '@store/auth/auth'
import config from '@app/config'
import jwt_decode from 'jwt-decode'

const upload = (path: string, method: 'GET' | 'PUT' | 'POST' | 'DELETE' | 'PATCH', base64: string) => {
  const tokens = auth.store.getState().OAuth
  const decrypted_token: { email: string } | undefined =
    (config.env === 'debug' || config.env === 'intma') && tokens ? jwt_decode(tokens.id_token) : undefined
  const email = decrypted_token && (decrypted_token.email as string)

  if (tokens && tokens.expire_at < new Date().getTime()) {
    auth.actions.resetTokens()
    return Promise.reject('Expiration token')
  }

  if (!tokens) {
    return Promise.reject('Missing tokens')
  } else {
    return new Promise((res, rej) => {
      const extracted = extractB64data(base64)
      const binaries = b64toBlob(extracted.data, extracted.mime)
      const data = new FormData()
      data.append('importFile', binaries)
      const xhr = new XMLHttpRequest()
      xhr.withCredentials = true
      xhr.onload = (e: any) => {
        if (e.target.status >= 400) {
          rej(e.target)
        } else {
          res(e.target.responseText)
        }
      }
      xhr.open(method, path)
      email
        ? xhr.setRequestHeader('X-Email', email)
        : xhr.setRequestHeader('Authorization', `Bearer ${tokens.id_token}`)
      xhr.send(data)
    })
  }
}

const b64toBlob = (b64Data: string, contentType: string, size?: number) => {
  const sliceSize = size || 512
  const byteCharacters = atob(b64Data)
  const byteArrays = []
  for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
    const slice = byteCharacters.slice(offset, offset + sliceSize)
    const byteNumbers = new Array(slice.length)
    for (let i = 0; i < slice.length; i++) {
      byteNumbers[i] = slice.charCodeAt(i)
    }
    const byteArray = new Uint8Array(byteNumbers)
    byteArrays.push(byteArray)
  }
  const blob = new Blob(byteArrays, { type: contentType })
  return blob
}

/*
 *  Extract mime type from base64 formatted as data:image/jpeg;base64,/9j/4......
 */

const extractB64data = (b64Data: string) => {
  const mimeSplit = b64Data.split(/;(.+)/, 2)
  if (mimeSplit.length < 2) {
    throw new Error('invalid base64 format')
  }
  const mimes = mimeSplit[0].split(/:(.+)/, 2)
  if (mimes.length < 2) {
    throw new Error('invalid mime format')
  }
  const mime = mimes[1]
  const datas = mimeSplit[1].split(/,(.+)/, 2)
  if (datas.length < 2) {
    throw new Error('invalid data format')
  }
  const data = datas[1]
  return {
    mime,
    data,
  }
}

export { b64toBlob, extractB64data }
export default upload
